import React from 'react';
import { dataKeyAttribute, dataIndexAttribute } from '../../constants';
function Item({ children, className, id, index, refs }) {
    const ref = React.useRef(null);
    refs[String(index)] = ref;
    return (React.createElement("div", Object.assign({ className: className }, { [dataKeyAttribute]: id, [dataIndexAttribute]: index }, { ref: ref }), children));
}
export default React.memo(Item);
